import { useMap } from '@vis.gl/react-google-maps';
import { useAtomValue } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useEffect, useRef, useState } from 'react';
import {
  selectedPartnerMapTeamId,
  teamDetailPanelVisible,
  viewAllTeamId,
} from '@/common/atoms/community';
import { useGetTeamOrganization } from '../useGetTeamOrganization';
import { computeViewAllTeamsBounds } from './helpers';

type ShowAllTeamLocationsFn = (teamId: string) => void;

export function useShowAllTeamLocations(): ShowAllTeamLocationsFn {
  const map = useMap();
  const viewAllTeam = useAtomValue(viewAllTeamId);
  const { teams } = useGetTeamOrganization(viewAllTeam);
  // Keying the fit off the click (not the selected team) lets re-clicking the
  // team you're already viewing re-center the map, while SWR revalidations don't.
  const [fitRequest, setFitRequest] = useState(0);
  const fittedRequestRef = useRef(0);

  useEffect(() => {
    if (!map || !viewAllTeam || !teams) {
      return;
    }
    if (fittedRequestRef.current === fitRequest) {
      return;
    }
    const bounds = computeViewAllTeamsBounds(teams);
    if (bounds) {
      map.fitBounds(bounds);
      fittedRequestRef.current = fitRequest;
    }
  }, [map, viewAllTeam, teams, fitRequest]);

  return useAtomCallback((_get, set, teamId: string) => {
    set(teamDetailPanelVisible, false);
    set(selectedPartnerMapTeamId, undefined);
    set(viewAllTeamId, teamId);
    setFitRequest((request) => request + 1);
  });
}
